export const initialise = ():void => {
    const postAlertEmailInputs = document.querySelectorAll<HTMLInputElement>(
        ".edit-post-alert__email"
    );

    postAlertEmailInputs.forEach((input) => {
        input.placeholder = "{{js.resources.postAlertEmailPlaceholder}}";
    });
};